import React, { useState, useEffect } from "react";

const AdminReports = () => {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState(""); // State to hold the search query

  useEffect(() => {
    // Fetch reports only for the logged-in user
    const fetchReports = async () => {
      try {
        const response = await fetch(
          `https://api.swalokgroup.com/api/get-all-reports`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch reports");
        }
        const data = await response.json();
        data.sort((a, b) => new Date(b.visit_date) - new Date(a.visit_date));
        setReports(data); // Store the reports data in state
      } catch (error) {
        console.log(error.message);
      } finally {
        setLoading(false); // Set loading to false after the request completes
      }
    };

    fetchReports();
  }, []);

  const formatDate = (dateString) => {
    const date = new Date(dateString); // Create Date object
    return date.toLocaleDateString(); // Default format is 'MM/DD/YYYY' in the browser's locale
  };

  // Filter reports based on the search query (team member's name)
  const filteredReports = reports.filter((report) =>
    report.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <>
      <section className="py-5">
        <div className="container">
          <div className="sec-subheading">
            <hr />
            <span>Daily Work Reports</span>
            <hr />
          </div>

          <div className="d-flex justify-content-end my-3">
            <input
              type="text"
              className="form-input w-auto"
              placeholder="Search by Name"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)} // Update search query state
            />
          </div>

          <div className="table-responsive text-center mt-4">
            <table className="w-100">
              <thead>
                <tr className="bg-light para-text">
                  <th className="py-3 px-2">S. No</th>
                  <th className="py-3 px-2">Member Name</th>
                  <th className="py-3 px-2">Role</th>
                  <th className="py-3 px-2">Visit Date</th>
                  <th className="py-3 px-2">Site Name</th>
                  <th className="py-3 px-2">Reason</th>
                  <th className="py-3 px-2">Places Visited</th>
                </tr>
              </thead>

              <tbody>
                {loading && (
                  <tr>
                    <td colSpan="7" className="py-3 px-2">
                      Loading reports...
                    </td>
                  </tr>
                )}

                {filteredReports.length === 0 ? (
                  <tr>
                    <td colSpan="7" className="py-3 px-2">
                      No reports found.
                    </td>
                  </tr>
                ) : (
                  filteredReports.map((report, index) => (
                    <tr
                      className="text-muted para-text text-capitalize"
                      key={report.id}
                    >
                      <td className="py-3 px-2">{index + 1}</td>
                      <td className="py-3 px-2">{report.name}</td>
                      <td className="py-3 px-2">{report.category}</td>
                      <td className="py-3 px-2">
                        {formatDate(report.visit_date)}
                      </td>
                      <td className="py-3 px-2">{report.site}</td>
                      <td className="py-3 px-2">{report.reason}</td>
                      <td className="py-3 px-2">{report.places}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
          {/* table ends */}
        </div>
      </section>
    </>
  );
};

export default AdminReports;
